<template>
  <div data-component-group="pins-panels" data-component="page">
    <div class="page-type">
      {{ pageName }}
    </div>

    <template v-if="hasPageObject">
      {{ pageObjectName }}
    </template>
  </div>
</template>

<script>
  import { isObj, isStr, isNull, capitalize } from '../../../utils';

  export default {
    props: {
      pin: {
        type: Object,
        required: true,
        validator(value) {
          return (
            isObj(value.page) &&
            isStr(value.page.name) &&
            (isNull(value.page_object) ||
              (isObj(value.page_object) && isStr(value.page_object.name)))
          );
        },
      },
    },
    computed: {
      pageName() {
        return capitalize(this.pin.page.name);
      },
      pageObjectName() {
        return capitalize(this.pin.page_object.name);
      },
      hasPageObject() {
        return isObj(this.pin.page_object);
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='pins-panels'] {
  &[data-component='page'] {
    font-size: $text-size-sm;
    color: var(--c-text-muted);

    &.status-success {
      color: map.get($colors, success);
    }

    &.status-danger {
      color: rgb(var(--v-theme-error));
    }

    .page-type {
      font-weight: bold;
    }
  }
}
</style>
